import { useState } from 'react';
import { ArrowLeftIcon } from 'icons';
import { GetStaticProps } from 'next';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { isBrowser } from 'modules/global';
import { OTMQuiz, OTMResults, OTMUniversities, useOTMQuizTest } from 'modules/otms-list';

import { NextHead } from 'components';

const OTMRecommendTestPage = () => {
  const t = useTranslations();
  const { push, back } = useRouter();
  const [currentStep, setCurrentStep] = useState<'quiz' | 'results' | 'universities'>('quiz');
  const [resultsData, setResultsData] = useState<any[]>([]);
  const [selectedField, setSelectedField] = useState<string | null>(null);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const { otmQuiz, isLoading } = useOTMQuizTest();

  const handleQuizComplete = (data: any[]) => {
    setResultsData(data);
    setCurrentStep('results');
  };

  const handleFieldSelect = (fieldId: string | null) => {
    setSelectedField(fieldId);
    setCurrentStep('universities');
  };

  const handleBack = () => {
    if (currentStep === 'results') {
      setCurrentStep('quiz');
    } else if (currentStep === 'universities') {
      setCurrentStep('results');
    } else if (isBrowser() && window.history.length > 1) {
      back();
    } else {
      push('/');
    }
  };

  return (
    <>
      <NextHead title={t('meta.otms_list.title')} description={t('meta.otms_list.description')} />

      <div className="relative mx-auto mt-5 max-w-[1000px] md:my-7 md:h-screen md:p-4">
        <div className="flex items-center justify-between p-4 md:p-0">
          <div
            onClick={handleBack}
            className="inline-flex cursor-pointer items-center justify-start gap-2  font-semibold"
          >
            <ArrowLeftIcon /> {t('common.ortga_qaytish')}
          </div>
          {currentStep === 'quiz' && (
            <div className="space-x-3 rounded-xl bg-indigo-600 px-4 py-1 text-white sm:hidden">
              <span>{t('savollar')}</span>
              <span>
                {currentQuestionIndex + 1}/{otmQuiz?.length || 0}
              </span>
            </div>
          )}
        </div>

        {currentStep === 'quiz' && (
          <OTMQuiz
            questions={otmQuiz}
            isLoading={isLoading}
            currentQuestionIndex={currentQuestionIndex}
            setCurrentQuestionIndex={setCurrentQuestionIndex}
            onComplete={handleQuizComplete}
          />
        )}
        {currentStep === 'results' && <OTMResults results={resultsData} onFieldSelect={handleFieldSelect} />}
        {currentStep === 'universities' && <OTMUniversities fieldId={selectedField} results={resultsData} />}
      </div>
    </>
  );
};

export default OTMRecommendTestPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => ({
  props: {
    messages: (await import(`../messages/${locale}.json`)).default
  }
});
